<div class="coming-soon-container">
  <mat-card class="coming-soon-card">
    <mat-card-content>
      <div class="icon-wrapper">
        <mat-icon aria-hidden="false" aria-label="Hourglass icon">hourglass_empty</mat-icon>
      </div>
      <h1>{{ 'COMING_SOON.TITLE' | transloco }}</h1>
      <p>{{ 'COMING_SOON.MESSAGE' | transloco }}</p>
      <!-- <mat-progress-spinner
        class="spinner"
        [mode]="'indeterminate'"
        diameter="50">
      </mat-progress-spinner> -->
    </mat-card-content>
  </mat-card>
</div>
